<template>
  <div class="v-application">
    <div class="v-data-table pa-5 theme--light">
      <div class="v-data-table__wrapper">
        <table>
          <colgroup>
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
          </colgroup>
          <thead class="v-data-table-header">
          <tr>
            <th role="columnheader" scope="col" aria-label="订单号" class="text-start"><span>订单号</span></th>
            <th role="columnheader" scope="col" aria-label="包裹数量/总量" class="text-start"><span>包裹数量/总量</span></th>
            <th role="columnheader" scope="col" aria-label="金额" class="text-center"><span>金额</span></th>
            <th role="columnheader" scope="col" aria-label="订单状态" class="text-center"><span>订单状态</span></th>
            <th role="columnheader" scope="col" aria-label="收件人" class="text-center"><span>收件人</span></th>
            <th role="columnheader" scope="col" aria-label="物流服务商" class="text-center"><span>物流服务商</span></th>
            <th role="columnheader" scope="col" aria-label="物流单号" class="text-center"><span>物流单号</span></th>
            <th role="columnheader" scope="col" aria-label="订单日期" class="text-center"><span>订单日期</span></th>
            <!--<th role="columnheader" scope="col" aria-label="" class="text-start"><span></span></th>-->
          </tr>
          </thead>
          <tbody>
          <tr class="">
            <td class="text-start">{{json[2].value}}</td>
            <td class="text-start"><span>{{json[4].value}}</span></td>
            <td class="text-center"><span>{{json[5].value}}</span></td>
            <td class="text-center"><span>{{json[7].value}}</span></td>
            <td class="text-center">{{json[13].value[0].value}}</td>
            <td class="text-center">{{json[8].value}}</td>
            <td class="text-center">{{json[0].value}}</td>
            <td class="text-center">{{json[9].value}}</td>
            <!--<td class="text-start">-->
            <!--<button type="button" class="v-btn v-btn&#45;&#45;text theme&#45;&#45;light v-size&#45;&#45;small primary&#45;&#45;text"><span-->
            <!--class="v-btn__content">查看订单</span></button>-->
            <!--</td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix" style="display: flex;align-items: center">
        <div style="width: 6px; height: 17px; background: #ff8a23 !important; border-radius: 2px;"></div>
        <div style="margin-left: 1rem">货物清单</div>
      </div>
      <el-form :inline="true" v-for="(item,i) in json[12].value" :key="i">
        <el-form-item label="" v-for="(item2,i2) in item" :key="i2">
          <el-input readonly v-model="item2.value"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix" style="display: flex;align-items: center">
        <div style="width: 6px; height: 17px; background: #ff8a23 !important; border-radius: 2px;"></div>
        <div style="margin-left: 1rem">收件人地址</div>
      </div>
      <div class="pb-5">
        <div>{{json[13].value[0].value}}</div>
        <div>{{json[13].value[3].value}}{{json[13].value[4].value}} 邮编:{{json[13].value[2].value}}</div>
        <div></div>
        <div>{{json[13].value[1].value}}</div>
      </div>
    </el-card>

  </div>
</template>

<script>
  let _ = require('lodash')
  export default {
    name: 'stuk',
    props: ['json'],
    components: {},
    data() {
      return {}
    },
    created() {

    },
    methods: {}
  }
</script>
<style scoped>
</style>

<style scoped lang="scss">
  .v-application {
    font-family: PingFangSC-Regular, PingFang SC, serif;
    line-height: 1.5;
  }
  .v-data-table-header {
    background-color: #f8fbff;
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:last-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:last-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-bottom: thin solid rgba(0, 0, 0, .12);
  }

  *, :after, :before {
    background-repeat: no-repeat;
    box-sizing: inherit;
  }

  table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    padding: 0 16px;
    transition: height .2s cubic-bezier(.4, 0, .6, 1);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: rgba(0, 0, 0, .6);
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: .75rem;
    line-height: 48px;
    height: 48px;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    padding: 0 16px;
    transition: height .2s cubic-bezier(.4, 0, .6, 1);
  }

  .v-application .text-center {
    text-align: center !important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td {
    font-size: .875rem;
    height: 48px;
    line-height: 48px;
  }

  .v-application .d-flex {
    display: flex !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_bill/stuk/index.vue